<template>
    <footer class="footer d-flex justify-content-start align-items-center">
        <img class="h-100" src="@/assets/icons/novonordisk.svg" alt="novordisk logo">
        <div class="d-flex justify-content-center flex-grow-1 text-white">
            <span>
                <b-link class="text-white" :to="{name: 'legal-note'}">{{ $t('footer.legalNote') }}</b-link> /
                <b-link class="text-white" :to="{name: 'cookies-policy'}">{{ $t('footer.cookiesPolicy') }}</b-link> /
                <b-link class="text-white" :to="{name: 'contact'}">{{ $t('footer.contact') }}</b-link>
             </span>
        </div>
        <a target="_blank" href="http://lapisoft.es/" class="h-50 mr-3">
            <img class="h-100" src="@/assets/lapisoft.png" alt="lapisoft">
        </a>
        <!--        <img class="h-100" src="@/assets/icons/novonordisk.svg" alt="novordisk logo">-->
    </footer>
</template>

<script>
export default {
    name: "TheFooter"
};
</script>

<style scoped>
.footer {
    background-color: #444444;
}
</style>